<div [ngClass]="success_sent ? 'modal fade close-mod push-modal-center' : 'modal fade close-mod'" id="careers-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-center-align">
        <div class="modal-content">

            <div class="modal-body">
                <button type="button" (click)="clearForm(requestForm)" class="close" data-dismiss="modal">&times;</button>

                <div class="contactus-details-right enquiry-form">
                    <form #requestForm="ngForm">
                        <h3 *ngIf="!success_sent" id="career-header" class="enquiry-title">Application Form</h3>

                        <div class="con-tac">

                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="1" required id="career-name" type="text" name="name" class="input-field" [(ngModel)]="career_submit.name" #fullPatientName="ngModel" placeholder="" #nameit />
                                <label for="career-name" class="input-label">Name<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fullPatientName.touched && fullPatientName.errors?.required && !success_sent">
                                    Name is required!
                                </div> -->
                            </div>

                            <div class="form-group" *ngIf="!success_sent">
                                <label for="role" class="mt-3">Job Title<span class="required-marker">*</span></label>
                                <select class="form-control custom-dd" id="role" name="role" [(ngModel)]="career_submit.job_title">
                                  <option>Full Stack Developer</option>
                                  <option>Testing Engineer</option>
                                  <option>Flutter Developer</option>
                                  <option>Sales and Business Development</option>
                                </select>
                              </div>

                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="2" required pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" name="email" class="input-field" [(ngModel)]="career_submit.email" #fullemail="ngModel"
                                    placeholder="" />
                                <label class="input-label" for="email">Email<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.required && !success_sent">
                                    Email is required!
                                </div> -->
                                <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.pattern ">
                                    Email is invalid!
                                </div>
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="3" required id="career-phone" type="text" name="career-phone" class="input-field" [(ngModel)]="career_submit.phone" #fullcontactnumber="ngModel" pattern="^[6-9]\d{9}$" placeholder="" />
                                <label for="career-phone" class="input-label">Mobile<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fullcontactnumber.touched && fullcontactnumber.errors?.required && !success_sent">
                                    Contact number is required!
                                </div> -->
                                <div class="form-text warning" *ngIf="fullcontactnumber.errors?.pattern">
                                    Invalid mobile number
                                </div>
                            </div>


                            <div class="input" *ngIf="!success_sent">
                                <input tabindex="4" type="text" class="input-field" required placeholder="" name="location" [(ngModel)]="career_submit.location" #fulllocation="ngModel">
                                <label for="location" class="input-label">Location<span class="required-marker">*</span></label>

                                <!-- <div class="form-text warning" *ngIf="fulllocation.touched && fulllocation.errors?.required && !success_sent">
                                    Location is required!
                                </div> -->
                            </div>

                            <div class="form-group mt-3">
                                <label for="resume">Resume</label>
                                <input type="file" class="form-control-file" id="resumeFile">
                            </div>

                            <div class="text-center">
                                <div class="alert alert-success" role="alert" *ngIf="success_sent">Submitted Successfully!</div>
                                <button *ngIf="!success_sent" type="submit" value="submit" class="btn button brand-button enquiry-but" name="submit_request" (click)="submitRequest();" [disabled]="isInvalid()"><i *ngIf="login_spinner" class="fas fa-spinner animate-spinner"></i> Submit</button>
                            </div>

                        </div>
                        <!-- con-tac -->
                    </form>
                    <!-- contactus-details-right -->
                </div>
                <!-- contactus-details-right -->
            </div>
        </div>
    </div>
</div>